import DataGrid, { Column, FilterPanel, FilterRow, HeaderFilter, Pager, Paging, Selection, Sorting } from 'devextreme-react/data-grid';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Confirm, Modal } from 'semantic-ui-react';
import { smsTemplateApi } from '../../../../api/sms/smsTemplateApi';
import { smsNewApi } from '../../../../api/sms/smsApi';
import { DangerButton, DefaultButton, PrimaryButton } from '../../../../components/editor/button';
import { useCommonContext } from '../../../../contexts/common';
import { showNotify } from '../../../../helpers/toast';
import styles from '../phe-duyet/PheDuyetModal.module.css';

const PheDuyetModal = ({ dataSource, onSuccess, onCancel }) => {
    const { translate } = useCommonContext();
    const [selectedIds, setSelectedIds] = useState([]);
    const [smssPheDuyet, setSmssPheDuyet] = useState([]);
    const [isShowPreviewModal, setIsShowPreviewModal] = useState(false);
    const [isShowConfirm, setIsShowConfirm] = useState(false);
    const [isShowRejectConfirm, setIsShowRejectConfirm] = useState(false);
    const [isPheDuyet, setIsPheDuyet] = useState(false);
    const { user } = useSelector((x) => x.auth);
    const [smsTemplate, setSmsTemplate] = useState();
    const [preViewSource, setPreViewSource] = useState();
    const [dataSourceFilter, setDataSourceFilter] = useState([]);

    const onPheDuyetClick = async () => {
        setIsShowConfirm(true)
    }
    const onRejectPheDuyetClick = async () => {
        setIsShowRejectConfirm(true)
    }
    const onSendPheDuyetSubmit = async () => {
        setIsPheDuyet(true);
        if (selectedIds == null || selectedIds == undefined) {
            showNotify({ text: 'Vui lòng chọn sms cần phê duyệt', type: 'error' });
            return;
        }
        else {
            const res = await smsNewApi.ApproveSms(selectedIds)
            setIsPheDuyet(false)
            if (res.is_success) {
                setIsShowConfirm(false)
                showNotify({ text: "Đã phê duyệt thành công", type: "success" });
                const filteredArray = dataSourceFilter.filter(item => !selectedIds.includes(item.id));
                setDataSourceFilter(filteredArray)
                // onSuccess();

            } else {
                showNotify({ text: "Có lỗi xảy ra", type: "error" })
            }
        }
    }
    const onRejectPheDuyetSubmit = async () => {
        setIsPheDuyet(true);
        if (selectedIds == null || selectedIds == undefined) {
            showNotify({ text: 'Vui lòng chọn sms cần từ chối phê duyệt', type: 'error' });
            return;
        }
        else {
            const res = await smsNewApi.RejectSms(selectedIds)
            setIsPheDuyet(false)
            if (res.is_success) {
                setIsShowRejectConfirm(false);
                showNotify({ text: "Đã từ chối thành công", type: "success" });
                const filteredArray = dataSourceFilter.filter(item => !selectedIds.includes(item.id));
                setDataSourceFilter(filteredArray)
                // onSuccess();
            } else {
                showNotify({ text: "Có lỗi xảy ra", type: "error" })
            }
        }
    }
    useEffect(() => {
        setDataSourceFilter(dataSource)
    }, [dataSource]);
    useEffect(() => {
        console.log(dataSourceFilter)

        const data = dataSourceFilter.filter(x => x.user_id_pheduyet == user.id && x.total_user > 0 && x.user_id_daduyet == 0);
        setSmssPheDuyet(data)
    }, [dataSourceFilter]);

    const handleGetDetail = async (smsTemplateId) => {
        if (smsTemplateId > 0) {
            const res = await smsTemplateApi.Detail(smsTemplateId);
            if (res.is_success) {
                setSmsTemplate(res.data)
            }
        }
    }
    const bodyParams = useMemo(() => {
        if (smsTemplate && smsTemplate.body_params) {
            return smsTemplate.body_params.split(',');
        }
        return [];
    }, [smsTemplate])
    const preViewHtml = useMemo(() => {
        if (smsTemplate && preViewSource) {
            let html = smsTemplate.body;
            bodyParams.forEach(p => {
                // debugger
                html = html.replace(`<span>@</span>${p}</span>`, `<span></span>${preViewSource[p]}</span>`)
            });
            return html;
        }
        return "";
    }, [preViewSource, smsTemplate, bodyParams])
    const previewRender = (data) => {
        return (
            <div>
                <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        btnPreview_click(data.data);
                    }}
                >
                    <i aria-hidden="true" className="fa fa-eye" style={{ color: '#54CA7D' }}></i>{' '}
                </span>
            </div>
        );
    };
    const btnPreview_click = (data) => {
        handleGetDetail(data.ts_sms_template_id)
        setPreViewSource(data)
        setIsShowPreviewModal(true);
    };
    return (
        <>
            <Modal open={true} size="large" dimmer={"blurring"} onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}>
                <Modal.Header>
                    <p>{translate('Phê duyệt sms')}</p>
                </Modal.Header>
                <Modal.Content>
                    <form className='ui'>
                        <div className="col-md-12 padding-top-5">
                            <h4>Chọn danh sách sms phê duyệt</h4>
                            <DataGrid
                                // ref={grid}
                                keyExpr="id"
                                dataSource={smssPheDuyet}
                                columnHidingEnabled={false}
                                columnAutoWidth={false}
                                showBorders={true}
                                showColumnLines={true}
                                showRowLines={true}
                                rowAlternationEnabled={true}
                                allowColumnResizing={true}
                                columnResizingMode={'nextColumn'}
                                hoverStateEnabled={true}
                                focusedRowEnabled={false}
                                height={window.innerHeight - 250}
                                className={'table-noborder-left'}
                                wordWrapEnabled={false}
                                onSelectionChanged={({ selectedRowKeys }) => setSelectedIds(selectedRowKeys)}
                            >
                                <Column minWidth={350} dataField={"name"} caption={"Mẫu email"} cellRender={(cell) => {
                                    return <Link to={`../../send-sms-detail/${cell.data.ts_sms_template_id}/${cell.data.id}`}>
                                        {cell.data.name}
                                    </Link>
                                }} />
                                <Column minWidth={150} dataField={"nguoi_tao"} caption={"Người tạo"} />
                                <Column minWidth={150} dataField={"ngay_tao"} caption={"Ngày tạo"} format={"dd/MM/yyyy"} dataType={"date"} />
                                <Column minWidth={150} dataField={"nguoi_phe_duyet"} caption={"Người phê duyệt"} />
                                <Column minWidth={150} dataField={"ngay_phe_duyet"} caption={"Ngày phê duyệt"} format={"dd/MM/yyyy"} dataType={"date"} />
                                <Column minWidth={200} dataField={"trang_thai_phe_duyet"} caption={"Trạng thái phê duyệt"} />
                                <Sorting mode="multiple" />
                                <Paging defaultPageSize={20} />
                                <Selection mode="multiple"></Selection>
                                <FilterRow visible={true} />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 20, 50, 200, 500]}
                                    infoText={`${translate('Trang')} {0} /{1} ({2} ${translate(
                                        'dòng'
                                    )})`}
                                    showInfo={true}
                                />
                            </DataGrid>
                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={"Đóng"} onClick={() => {
                            onCancel();
                        }} />
                        <DangerButton text={`Từ chối (${selectedIds.length})`}

                            onClick={onRejectPheDuyetClick}
                        />
                        <PrimaryButton text={`Phê duyệt (${selectedIds.length})`}

                            onClick={onPheDuyetClick}
                        />
                    </div>
                </Modal.Actions>
            </Modal>
            {isShowConfirm &&
                <Confirm className={styles.modal_center}
                    open={true}
                    dimmer={'blurring'}
                    header={translate('Lưu ý')}
                    content={translate('Bạn có chắc chắn muốn phê duyệt các sms đã chọn ?')}
                    size="mini"
                    cancelButton={() => {
                        return (
                            <>
                                <DefaultButton text={"Để sau"} onClick={() => {
                                    setIsShowConfirm(false);
                                }} />
                            </>
                        );
                    }}
                    confirmButton={() => {
                        return (
                            <>
                                <PrimaryButton text={"Xác nhận"} icon="fas fa-paper-plan"
                                    isLoading={isPheDuyet}
                                    onClick={() => {
                                        onSendPheDuyetSubmit();
                                    }} />
                            </>
                        );
                    }}
                />
            }

            {isShowRejectConfirm &&
                <Confirm className={styles.modal_center}
                    open={true}
                    dimmer={'blurring'}
                    header={translate('Lưu ý')}
                    content={translate('Bạn có chắc chắn muốn từ chối phê duyệt các sms đã chọn ?')}
                    size="mini"
                    cancelButton={() => {
                        return (
                            <>
                                <DefaultButton text={"Để sau"} onClick={() => {
                                    setIsShowRejectConfirm(false);
                                }} />
                            </>
                        );
                    }}
                    confirmButton={() => {
                        return (
                            <>
                                <PrimaryButton text={"Xác nhận"} icon="fas fa-paper-plan"
                                    isLoading={isPheDuyet}
                                    onClick={() => {
                                        onRejectPheDuyetSubmit();
                                    }} />
                            </>
                        );
                    }}
                />
            }
            {isShowPreviewModal &&
                <Modal
                    className={styles.modal_center}
                    open={true}
                    size="small"
                    dimmer={'blurring'}
                    onClose={() => {
                        // setisShowEditModal(false)
                    }}
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                >
                    <Modal.Header>
                        Preview
                    </Modal.Header>
                    <Modal.Content>
                        <div dangerouslySetInnerHTML={{ __html: preViewHtml }} />
                    </Modal.Content>
                    <Modal.Actions>
                        <DefaultButton text={"Đóng"}
                            onClick={() => {
                                setIsShowPreviewModal(false);
                            }} />
                    </Modal.Actions>
                </Modal>
            }
        </>
    );
};
export default PheDuyetModal;
